module.exports = __webpack_public_path__ + "static/img/3.8ed9ee4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/four/3.png
// module id = S+FI
// module chunks = 1